module.exports = __webpack_public_path__ + "media/images/hero-f3d455b9c88e8cbf61c01a60422dbaa3.jpg";